export const USER_TYPE_FROM_KEY = {
  teachers: "Teacher",
  teacher: "Teacher",
  "non-teachers": "Non-Teacher",
  "non-teacher": "Non-Teacher",
};

export const ADMIN_LOCATION_LEVEL_USER_OPTIONS = {
  ADMIN_LOCATION_USER: "Admin Location User",
  ACCOUNT_NO_DESC_USER: "Account No Desc User",
  PAYPOINT_DESC_USER: "Paypoint Desc User",
};

export const BUREAUCRAT_USER = 'Bureaucrat User';
export const SUPER_USER = "Super User";
export const NON_TEACHER_USER = "Non-Teacher User";
export const TEACHER_USER = "Teacher User";

export const TEACHER = "Teacher";

export const NON_TEACHER = "Non-Teacher";
